import React, { useEffect } from "react";
import { isAndroid, isIOS, isMobile } from "react-device-detect";
import { useSelector } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import PrivacyPolicyRoute from "./pages/PrivacyPolicy/PrivacyPolicyRoute";
import { RootState } from "./redux/store";
import { AuthRoutes } from "./routes/auth-routes";
import { pharmacyRoutes } from "./routes/pharmacyRoutes";
import { warehouseRoutes } from "./routes/warehouseRoutes";
import {
  ArabicCode,
  DefaultAppStoreLinkForMobileApp,
  DefaultGooglePlayLinkForMobileApp,
  EnglishCode,
} from "./utils/constants/CommonConstants";
import ErrorPage from "./pages/ErrorPages/ErrorPage";

const App: React.FC = () => {
  const { role, user, isAuthenticated } = useSelector(
    (state: RootState) => state.auth,
  );

  const { ProfileUserInfo } = useSelector((state: RootState) => state.profile);

  const navigate = useNavigate();
  const location = useLocation();
  //? ================= Tablet Redirect to App Store =================
  useEffect(() => {
    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera;

    const isIPad =
      /iPad/.test(userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    const isAndroidTablet = isAndroid && !isMobile && window.innerWidth >= 768;

    const isRealMobileDevice = isAndroid || isIOS || isIPad || isAndroidTablet;

    const isSmallScreen = window.innerWidth <= 800;

    if (isRealMobileDevice && isSmallScreen) {
      if (isAndroid) {
        window.location.href = DefaultGooglePlayLinkForMobileApp;
      } else if (isIOS || isIPad) {
        window.location.href = DefaultAppStoreLinkForMobileApp;
      }
    }
  }, []);

  //? ================= Language Switcher =================
  useEffect(() => {
    const language = localStorage.getItem("language") || EnglishCode;
    const dir = language === ArabicCode ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
  }, []);

  //? ================= Prevent Go back to/from login =================
  useEffect(() => {
    if (ProfileUserInfo?.token && location?.pathname === "/auth/login") {
      navigate("/", {
        replace: true,
      });
    }
    if ((!isAuthenticated || !role) && location.pathname === "/") {
      navigate("/auth/login");
    }
  }, [ProfileUserInfo, navigate, role, location.pathname, window]);

  return (
    <Routes>
      <Route path="/auth/*">
        {AuthRoutes?.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={route.element}
            index={route.index}
          />
        ))}
      </Route>

      {user?.token && isAuthenticated && (
        <>
          {role === "pharmacy" &&
            pharmacyRoutes?.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={route.element}
                index={route.index}
              />
            ))}

          {role === "warehouse" &&
            warehouseRoutes?.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={route.element}
                index={route.index}
              />
            ))}
        </>
      )}
      <Route path="*" element={<ErrorPage />} />
      <Route path="PrivacyPolicy" element={<PrivacyPolicyRoute />} />
    </Routes>
  );
};

export default App;
